import React from 'react';
import withIcon from '../utilities/withIcon';

const IconDocumentSearch = () => {
  return (
    <g>
      <path d="m15.7432 12.8037-2.31-2.31a4.3289 4.3289 0 0 0 -1.4194-6.2927v-2.5535a.75.75 0 0 0 -.75-.75h-6.901a.7607.7607 0 0 0 -.53.22l-3.576 3.5754a.7609.7609 0 0 0 -.22.53v9.1294a.75.75 0 0 0 .75.75h10.4774a.75.75 0 0 0 .75-.75v-2.584c.1215-.0693.2449-.1335.3588-.2137l2.31 2.31a.75.75 0 0 0 1.0605-1.0605zm-5.8794-1.9468a2.8721 2.8721 0 1 1 2.8726-2.8721 2.8755 2.8755 0 0 1 -2.8726 2.8721zm-5.9131-7.7369v1.691h-1.6907zm6.5635 10.4824h-8.9771v-7.2914h3.1636a.75.75 0 0 0 .75-.75v-3.1635h5.0635v1.281a4.32 4.32 0 0 0 -.65-.0657 4.3721 4.3721 0 1 0 0 8.7441 4.3216 4.3216 0 0 0 .65-.0657z" />
    </g>
  );
};

export default withIcon(IconDocumentSearch);
